import microuniversoApi from "app/api/microuniversoApi"
import { atualizarItemAction, sobrescreverInformacoesAction } from "app/redux/orcamentoSlice"
import store from "app/redux/store/store"
import * as atualizacaoOrcamentoLegadoActions from 'app/redux/atualizacaoOrcamentoLegadoSlice'
import * as atualizacaoItensOrcamentoLegadoActions from 'app/redux/atualizacaoItensOrcamentoLegadoSlice'


import globalMU from "globalMU"
import {obterParametros} from "../parametro/obterParametros";
import { WindowMU } from "app/types/WindowMU"
import * as R from 'ramda'
import { definirPreservaDesconto } from "./definirPreservaDesconto"

declare var window:WindowMU

export type AlterarPrecoItemParams = {
    identificadorItem:number,
    preco:number,
    percentualDesconto:number,
    percentualBonificacao:number,
    atualizarEstadoLegadoImediatamente?: boolean,
    itemLegado?:any
    silent?: boolean,
    PARAMETRO_PERMITIR_PRESERVAR_DESCONTO_ITEM_ORCAMENTO?: string,
    preservaDesconto?: boolean
}

export async function alterarPrecoItem(params:AlterarPrecoItemParams) {
    try {
        globalMU.blockUI({tryPassiveLoading: true})
        
        const orcamentoAtualizado = await microuniversoApi.Orcamento.definirPrecoprodutoItem(
            params.identificadorItem,
            store.getState().orcamento.IdentificadorOrcamento,
            params.preco,
            params.percentualDesconto,
            params.percentualBonificacao,
        )

        const atualizarOrcamento = async () => {
            const itemAtualizado = orcamentoAtualizado.ItensOrcamento.find(i => i.Identificador == params.identificadorItem)
            const orcamentoLegado = window.orcamentoController.model

            orcamentoLegado.atualizar(
                orcamentoAtualizado,    //data
                params.atualizarEstadoLegadoImediatamente == true,  //ehParaAtualizarEstadoLegado
                true,   //ehParaAtualizarRedux
                params.silent === true //silent
            )

            store.dispatch(atualizarItemAction({
                identificador: params.identificadorItem,
                dados: {UltimaInformacaoAtualizada: "PRECO"}
            }))

            if (params.PARAMETRO_PERMITIR_PRESERVAR_DESCONTO_ITEM_ORCAMENTO == "S") {
                await definirPreservaDesconto({
                  identificadorItem: itemAtualizado.Identificador,
                  preservaDesconto: params.preservaDesconto
                })
              }
        }
        atualizarOrcamento()
    } finally {
        globalMU.unblockUI()
    }
}
